import React from "react";
import { ImageView } from "../core/Helpers/ImageView";
import { WowMainPhoto } from "./WowMainPhoto";

type Media = { type: "video" | "photo"; src: string };

type WowMainMediaProps = {
    media: Media;
    selected: boolean;
    onVideoEnded?: () => void;
    onProgress?: (progress: number) => void;
};

class WowMainMedia extends React.Component<WowMainMediaProps> {
    private videoRef = React.createRef<HTMLVideoElement>();

    componentDidUpdate(prevProps: WowMainMediaProps) {
        if (this.props.media.type !== "video") return;
        const v = this.videoRef.current;
        if (!v) return;

        if (this.props.selected && !prevProps.selected) {
            v.currentTime = 0;
            v.play().catch(() => {});
        } else if (!this.props.selected && prevProps.selected) {
            v.pause();
            v.currentTime = 0;
        }
    }

    render() {
        const { media, selected, onVideoEnded, onProgress } = this.props;

        return (
            <div className={`main-wow-image ${selected ? "main-wow-selected" : "main-wow-opacity-0"}`}>
                {media.type === "video" ? (
                    <div className="video-content-wow">
                        <video
                            ref={this.videoRef}
                            className="main-wow-media"
                            src={media.src}
                            muted
                            playsInline
                            preload="auto"
                            autoPlay
                            loop={false}
                            onTimeUpdate={(e) => {
                                const el = e.currentTarget;
                                if (el.duration) onProgress?.(el.currentTime / el.duration);
                            }}
                            onEnded={() => selected && onVideoEnded?.()}
                        />
                        <div className="video-black-back"/>
                    </div>
                ) : (
                    <WowMainPhoto photo={media.src} selected={selected}/>
                    // <ImageView source={media.src} />
                )}
            </div>
        );
    }
}

export { WowMainMedia };
